import { TEmojiId } from './room.types';

type TSocketCmdType =
  | 'roomEmoji'
  | 'privacy'
  | 'transcript'
  | 'geoLocation'
  | 'geoLocationOK'
  | 'geoLocationKO'
  | 'ejectAll'
  | 'peerAudio';

export interface ISocketCmd {
  peer_name: string;
  peer_id: string;
  emoji?: TEmojiId;
  broadcast?: boolean;
  type: TSocketCmdType;
}

export interface ICanvasPayload {
  canvasData: Record<string, any>;
  peerInfo?: {
    peerName: string;
    peerId: string;
  };
}

export enum ECommonSocketKeys {
  CMD = 'cmd',
  FILE = 'file',
  MESSAGE = 'message',
  CONNECT = 'connect',
  REMOVE_ME = 'removeMe',
  DISCONNECT = 'disconnect',
  PEER_ACTION = 'peerAction',
  USER_TYPING = 'userTyping',
  DELETE_FILE = 'deleteFile',
  EDIT_MESSAGE = 'editMessage',
  UPDATE_POLLS = 'updatePolls',
  AUDIO_VOLUME = 'audioVolume',
  ADMIT_ACTION = 'admitAction',
  SET_VIDEO_OFF = 'setVideoOff',
  NEW_PRODUCERS = 'newProducers',
  SPEECH_TO_TEXT = 'speechToText',
  DELETE_MESSAGE = 'deleteMessage',
  NEW_PEER_JOINED = 'newPeerJoined',
  CONSUMER_CLOSED = 'consumerClosed',
  UPDATE_PEER_INFO = 'updatePeerInfo',
  RECORDING_ACTION = 'recordingAction',
  MAGIC_PEN_PERMISSION = 'magicPenPermission',
  UPDATE_PEER_PERMISSION = 'updatePeerPermission',
  REQUEST_TO_ADMIT_ACTION = 'requestToAdmitAction',
  STOP_SCREEN_SHARING_ALL = 'stopScreenSharingAll',
  FETCH_PEERS_PERMISSIONS = 'fetchPeersPermissions',
  FORCE_STOP_SCREEN_SHARING = 'forceStopScreenSharing',
  PEERS_PERMISSIONS_UPDATED = 'peersPermissionsUpdated',
  REFRESH_PARTICIPANTS_COUNT = 'refreshParticipantsCount',
  REQUESTED_ACTION_PROCESSED = 'requestedActionProcessed',
}

export enum EMeetSocketKeys {
  CONSUMER_CLOSED = 'consumerClosed',
}
